<ng-container *isavAuthenticated="true">
    <a *isavMapContextOption (click)="open()" class="dropdown-item">
        <span class="icon mr-1" aria-hidden="true">
            <i class="fas fa-map-marker-alt"></i>
        </span>
        <span>Add new marker</span>
    </a>
</ng-container>
